import {BaseService} from "@/services/BaseService";
import {FuneralPlanSupplier} from "@/shared/domain/funeral-plan-supplier.model";
import http from "@/http-common";
import {FuneralPlanDetailsMobile} from "@/shared/domain/funeral-plan-details-mobile.model";

class FuneralPlanSupplierService extends BaseService<FuneralPlanSupplier>{
  public entityUrl = "funeral-plan-suppliers"

  getlAllPlanDetails(funeralPlanSupplierId: number) {
    return http.get<FuneralPlanDetailsMobile[]>(`${this.entityUrl}/${funeralPlanSupplierId}/planDetails`);
  }

  checkSupplierCode(supplierCode: string) {
    return http.get<any>(`${this.entityUrl}/checkSupplierCode/${supplierCode}`);
  }
}

export default new FuneralPlanSupplierService();



